import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { isPathwaysXDP } from 'bundles/unified-common/utils/showPathways';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';

// For general/desktop-inclusive changes, this can act as a standalone check.
export const useStreamlinedXDP = () => {
  const { marketingSource, productSlug } = usePageInfo();
  // marketingSource is undefined for Paid Ads and Google XDPs
  // productSlug is undefined non-XDP pages (e.g. LIHP)
  // isPathwaysXDP is true for slugs in the Pathways experiment; we want to exclude these
  const isRegularXDP = !marketingSource && !!productSlug && !isPathwaysXDP(productSlug);

  return isRegularXDP && GrowthDiscoveryEpicClient.get('useStreamlinedMWebXDP');
};

// For changes specific to mobile + tablet (<1024px), use this hook IF module is
// below the fold (if above, use useStreamlinedXDP in conjunction with <Media> block).
export const useMWebStreamlinedXDP = () => {
  const isStreamlinedXDP = useStreamlinedXDP();
  const isMWeb = useMediaQuery(breakpoints.down('sm'));

  return isStreamlinedXDP && isMWeb;
};

// For changes specific to mobile (<600px / NOT tablet), use this hook IF module is
// below the fold (if above, use useStreamlinedXDP in conjunction with <Media> block).
export const useMobileOnlyStreamlinedXDP = () => {
  const isStreamlinedXDP = useStreamlinedXDP();
  const isMobileDeviceWidth = useMediaQuery(breakpoints.down('xs'));

  return isStreamlinedXDP && isMobileDeviceWidth;
};
